import React from 'react';
import PropTypes from 'prop-types';
import {
  SelectButton,
  TitleLabel,
  Option,
  Input,
  OptionLabel,
} from './SelectableButton.styles';

const SelectableButton = ({
  label,
  name,
  options,
  onClick,
  onChange,
  value,
  fullWidth = false,
  disabled,
}) => {
  const handleChecked = (option) => value === option;

  return (
    <SelectButton fullWidth={fullWidth}>
      {label && <TitleLabel>{label}</TitleLabel>}
      {options.map((option) => (
        <Option
          type={options.length <= 2 ? 'basic' : 'multiple'}
          key={option.id}
          onClick={onClick}
        >
          <Input
            type='radio'
            id={option.id}
            value={option.value}
            name={name}
            onClick={onClick}
            onChange={(e) => onChange && onChange(e)}
            checked={value && handleChecked(option.value)}
            disabled={disabled}
          />
          <OptionLabel disabled={disabled} htmlFor={option.id}>
            {option.label}
          </OptionLabel>
        </Option>
      ))}
    </SelectButton>
  );
};

SelectableButton.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

export default SelectableButton;
